import Swiper from 'swiper';

function sliderReviews() {
  new Swiper('.swiper-reviews', {
    centeredSlides: false,
    initialSlide: 1,
    autoHeight: true,
    grabCursor: true,
    loop: true,
    spaceBetween: 16,
    slidesPerView: 1,
    breakpoints: {
      600: {
        spaceBetween: 16,
        autoHeight: true,
        initialSlide: 1,
        slidesPerView: 1.5,
      },
      1110: {
        initialSlide: 1,
        autoHeight: false,
        spaceBetween: 24,
        slidesPerView: 2,
      }
    }
  });
}
sliderReviews();